import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';
import { Form, Col, Badge, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink } from 'reactstrap';
import PropTypes from 'prop-types';
import { AppAsideToggler, AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
//import logo from '../../assets/img/brand/logo.svg'
import logo from '../../assets/img/brand/logo-small.png'
//import sygnet from '../../assets/img/brand/sygnet.svg'
import sygnet from '../../assets/img/brand/logo.png'
import Select from 'react-select';
import axios from 'axios';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultHeader extends Component {
  constructor(props) {
    super(props);    
    this.state = {
      redirectToReferrer: false,
    };
    this.logout = this.logout.bind(this);
  }  
   logout(){
     sessionStorage.setItem("userData",'');
     sessionStorage.clear();
     this.setState({redirectToReferrer: true});
   } 

  componentWillMount() {

  } 

  render() {
    if (this.state.redirectToReferrer) {
      return (<Redirect to={'/login'}/>)
    }
    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (

      <React.Fragment>      
        <img src={'assets/img/logo.png'} className='header__logo' alt=''/>
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default DefaultHeader;
